module.exports = __webpack_public_path__ + "img/img_4.472c3ee5.png";